import React from "react";
import { render } from "react-dom";
import App from "./containers/App/App";
import "./limeproxy.css";
// import dotenv from "dotenv";

// console.error("dotenv", dotenv.config("API_URL"));

render(<App />, document.getElementById("root"));

Array.prototype.random = function() {
  return this[Math.floor(Math.random() * this.length)];
};
